import axios from 'axios'
import { GLOBAL_API_DOMAIN } from '../config'

var httpClient = axios.create({
    baseURL: GLOBAL_API_DOMAIN,
    timeout: 60000,
    withCredentials: true
});
// Add a request interceptor
httpClient.interceptors.request.use(async (config) => {
    // Do something before request is sent
    return config;
}, async function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
httpClient.interceptors.response.use(async (response) => {
    // Do something with response data
    let { data: { status } } = response
    if (status === 403 || status === 22001) {
        // if (!window.browserHistory.location.pathname.startsWith('/login')) {
        //     window.browserHistory.push(`/login`)
        // }
    }
    return response.data;
}, async function (error) {
    // Do something with response error
    return Promise.reject(error);
});

export default httpClient



// WEBPACK FOOTER //
// ./src/util/httpClient.js